module.exports = __webpack_public_path__ + "static/media/01_A7_02.cd7302dd.png";